import React from 'react';
import { shape, node, string, bool, number, oneOfType } from 'prop-types';
import { getPrimaryIndustryNameById } from '@paddl/utils-js';
import { LogoCardWithText, MarkDownSection } from '../../../..';
import { DetailsWrapper } from '../../../Activity.styles';
export const WorkshopRead = _ref => {
  let {
    data: {
      details: {
        description,
        primaryIndustryId,
        commitmentMinutes,
        attendance: {
          online,
          inPerson
        },
        session: {
          name: sessionName
        },
        provider: {
          icon: providerIcon,
          name: providerName
        }
      }
    },
    editButton
  } = _ref;
  return /*#__PURE__*/React.createElement(DetailsWrapper, null, editButton, /*#__PURE__*/React.createElement("h1", {
    className: "headline"
  }, sessionName), /*#__PURE__*/React.createElement(LogoCardWithText, {
    avatarUrl: providerIcon,
    title: providerName,
    subtitle: "",
    isSubtitleShortened: true
  }), description ? /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(MarkDownSection, {
    markDown: description
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "tags"
  }, "".concat(primaryIndustryId ? "".concat(getPrimaryIndustryNameById(primaryIndustryId), " \u2022 ") : ''), "".concat(commitmentMinutes, " Minutes \u2022 "), [online ? 'Online' : undefined, inPerson ? 'In Person' : undefined].filter(Boolean).join(' / ')));
};
WorkshopRead.propTypes = {
  data: shape({
    details: shape({
      session: shape({
        name: string
      }).isRequired,
      provider: shape({
        name: string
      }).isRequired,
      attendance: shape({
        online: bool,
        inPerson: bool
      }).isRequired,
      description: string,
      primaryIndustryId: oneOfType([number, string]),
      hoursPerWeek: oneOfType([number, string]),
      commitmentMinutes: oneOfType([number, string])
    })
  }).isRequired,
  editButton: node
};
WorkshopRead.defaultProps = {
  editButton: undefined
};